<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('reports.reportRequestTab')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-md-12 card text-left">
      <div class="card-header"></div>
        <div class="card-content total-pagination pad-1">
          <data-tables-server
              class=""
              v-loading="loading"
              :data="clientsTableData"
              :search-def="{ show: false }"
              :pagination-props="paginationProps"
              :table-props="tableOptions"
              style="width: 100%;"
            >
            <el-table-column
              prop="id"
              label="Id"
            ></el-table-column>
            <el-table-column
              :min-width="120"
              :label="$t('customers.type')">
              <template slot-scope="props">
                <span>{{ mapReportType(props.row.type) }}</span>
              </template>
            ></el-table-column>
            <el-table-column
              :min-width="120"
              prop="from_date"
              :label="$t('reports.fromUppercase')"
            ></el-table-column>
            <el-table-column
              :min-width="120"
              prop="to_date"
              :label="$t('reports.toUppercase')"
            ></el-table-column>
            <el-table-column
              :min-width="120"
              prop="available_until"
              :label="$t('reports.availableUntil')"
            ></el-table-column>
            <el-table-column :min-width="80" prop="name" :label="$t('customers.status')">
              <template slot-scope="props">
                <span>{{ reportStatus(props.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :width="120" 
              :label="$t('general.actions')">
              <template slot-scope="props">
                <a v-if="props.row.file && Number(props.row.is_executed) === 1" class="btn btn-info btn-icon duplicate-prod" :href="apiUrl + '/reports/download-report/' + props.row.id + '?token=' + $session.get('token')" target="_blank">
                  <i class="ti-download"></i>
                </a>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import Vue from 'vue'
  import moment from 'moment'
  import {DatePicker} from 'element-ui'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  export default {
    components: {
      // GeneralTopBar,
      [DatePicker.name]: DatePicker
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.getData()
    },
    mounted () {
      console.log('mounted')
      this.getData()
    },
    data () {
      return {
        loading: false,
        currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
        clients: {
          'valid': [
            moment().date(1).format('YYYY-MM-DD'),
            moment().endOf('month').format('YYYY-MM-DD')
          ],
          searchClient: null,
          searchEmployee: null
        },
        paginationProps: {
          // pageSizes: [5, 10, 15],
          layout: 'prev, pager, next, sizes, total'
        },
        tableOptions: {
          defaultSort: {
            prop: 'name',
            order: 'ascending'
          }
        },
        labels: null,
        labelingPrimaryOption: null,
        totalClients: null,
        sortBy: 'name',
        sortOrder: 'asc',
        clientsTableData: [],
        pickerOptions: {
          disabledDate (date) {
            return date < moment().subtract(12, 'months').startOf('day')
          }
        },
        pickerNames: ['date_from', 'date_to'],
        apiUrl: null,
        reportTypes: {
          exportRaportPuncte: 'pointsReport'
        }
      }
    },
    methods: {
      paginationChanged (query) {
        if (query.type === 'page') this.getData(query)
        if (query.type === 'size') this.getData(query)
        if (query.type === 'sort') {
          if (query.sort.order) {
            this.sortBy = query.sort.prop
            this.sortOrder = query.sort.order === 'descending' ? 'desc' : 'asc'
          } else {
            this.sortBy = 'name'
            this.sortOrder = 'asc'
          }
          this.getData(query)
        }
      },
      getData (query) {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
          // start_date: this.clients.valid[0],
          // end_date: this.clients.valid[1],
          // search_client: this.clients.searchClient,
          // search_employee: this.clients.searchEmployee
        }
  
        // let sortColumn = ''
        // let sortType = ''
        // // let $dd = {}
        // if (query) {
        //   sortColumn = query.sort.prop
        //   sortType = query.sort.order === 'descending' ? 'desc' : 'asc'
        // } else {
        //   sortColumn = this.sortBy
        //   sortType = this.sortOrder
        // }
  
        // const sortOptions = {
        //   field: sortColumn,
        //   order: sortType
        // }
        // data = {
        //   ...data,
        //   ...sortOptions
        // }
  
        this.loading = true
        // const pageSize = query ? query.pageSize : 20
        // const page = query ? query.page : 1
        this.apiRequest('reports/pending-report', 'GET', data, response => {
          if (response.status === true) {
            this.clientsTableData = response.data
            // this.totalClients = response.data.total
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      downloadReport (id) {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        this.loading = true
        this.apiRequest('reports/download-pending-report', 'GET', data, response => {
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      reportStatus (report) {
        if (Number(report.is_executed) === -1) return 'Generarea a eșuat. Solicită din nou raportul.'
        if (Number(report.is_executed) === 1) return 'Procesat'
        return report.in_progress ? 'În procesare' : 'În așteptare'
      },
      mapReportType (type) {
        if (type === 'sql-products') return 'Toate produsele (CSV)'
        if (type === 'sql-coupon-orders') return 'Comenzi cu cupon (CSV)'
        return this.reportTypes[type] ? this.$t('reports.' + this.reportTypes[type]) : this.$t('reports.reportTypePlaceholder')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/ReportRequest.vue